module.exports = __webpack_public_path__ + "static/maggie-af6803fee4cdc0732208e60a226f81ef.png";